import React, { useRef, useState } from 'react';
import styled from 'styled-components/macro';
// assets
import { MdArrowDropDown } from 'react-icons/md';
// hooks
import { useOutsideAlerter } from '../hooks';
import { useTranslation } from 'react-i18next';

interface IDropdown {
  mainColor?: any;
  onSelectOption?: any;
  options: { value: boolean | string; label: string }[];
  menuStyle?: React.CSSProperties;
  value: { value: boolean | string; label: string } | null;
}

const DropdownContainer = styled.div`
  border-radius: 6px;
  border: 1px solid ${props => props.theme.colors.secondary[20]};
  min-width: 104px;
  width: 100%;
  padding: 12px 8px;
  height: 40px;
  box-sizing: border-box;
  position: relative;

  @media screen and (max-width: 320px) {
    margin-left: 3px;
  }
`;

const DropDownInput = styled.div`
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DropDownPlaceholder = styled.div`
  color: ${props => props.theme.colors.secondary[20]};
  font-size: 15px;
  font-weight: normal;
`;

const DropDownMenu = styled.div`
  box-shadow: 0px 6px 16px rgba(29, 30, 36, 0.09);
  background-color: #ffffff;
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  z-index: 3;
  border-radius: 6px;
`;

const DropDownOption = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  &:hover {
    background-color: #f2f4f6;
    color: #1c6acf;
  }
`;

export const EnhancedDropdown = (props: IDropdown) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownContainerRef = useRef(null);
  useOutsideAlerter(dropdownContainerRef, () => setIsMenuOpen(false));
  const { t } = useTranslation();

  return (
    <DropdownContainer ref={dropdownContainerRef}>
      <DropDownInput
        onClick={() => {
          setIsMenuOpen(!isMenuOpen);
        }}
      >
        <DropDownPlaceholder
          style={{ ...(props.value?.label && { color: '#272A32' }) }}
        >
          {props.value?.label ? props.value.label : t('Select...')}
        </DropDownPlaceholder>

        <MdArrowDropDown
          transform={isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
          color={'inherit'}
        />
      </DropDownInput>
      <DropDownMenu
        style={{ ...(!isMenuOpen && { display: 'none' }), ...props.menuStyle }}
      >
        {props.options.map((opt, index: number) => (
          <DropDownOption
            key={index}
            onClick={() => {
              props.onSelectOption(opt);
              setIsMenuOpen(false);
            }}
          >
            {opt.label}
          </DropDownOption>
        ))}
      </DropDownMenu>
    </DropdownContainer>
  );
};
